import { Dialog } from "@headlessui/react";
import React from "react";

const CommentModal = ({ showCommentModal, setShowCommentModal }) => {
  return (
    <Dialog
      open={showCommentModal}
      onClose={() => setShowCommentModal(false)}
      as="div"
      style={{ zIndex: "9999999999" }}
      className="fixed inset-0 z-10 flex flex-col items-center justify-center"
    >
      <Dialog.Overlay className="fixed inset-0 z-10 bg-black opacity-70" />
      <Dialog.Title />
      <Dialog.Description />
      <div className="z-10 h-4/5 w-[90%] rounded-xl bg-[#2D4F71] p-3 text-white">
        <h2 className="mt-4 mb-4 text-center text-2xl font-semibold">
          578 Comments
        </h2>
        <div className="h-[80%] overflow-y-scroll">
          <div className="mb-2.5 rounded-xl bg-[#81AFDD] p-2">
            <div className="flex items-center">
              <img
                src="https://img.learntube.ai/public-assets/AI_Syllabus_generator/Oval.png?updatedAt=1689681534956"
                width={32}
                height={32}
                alt=""
              />
              <p className="mx-2 font-medium">amyrobson</p>
              <p className="ml-2 opacity-50">1 month ago</p>
            </div>
            <p className="mt-2 leading-5">
              Impressive! Though it seems the drag feature could be improved.
            </p>
          </div>
          <div className="mb-2.5 rounded-xl bg-[#81AFDD] p-2">
            <div className="flex items-center">
              <img
                src="https://img.learntube.ai/public-assets/AI_Syllabus_generator/Oval.png?updatedAt=1689681534956"
                width={32}
                height={32}
                alt=""
              />
              <p className="mx-2 font-medium">amyrobson</p>
              <p className="ml-2 opacity-50">1 month ago</p>
            </div>
            <p className="mt-2 leading-5">
              Impressive! Though it seems the drag feature could be improved.
            </p>
          </div>
          <div className="mb-2.5 rounded-xl bg-[#81AFDD] p-2">
            <div className="flex items-center">
              <img
                src="https://img.learntube.ai/public-assets/AI_Syllabus_generator/Oval.png?updatedAt=1689681534956"
                width={32}
                height={32}
                alt=""
              />
              <p className="mx-2 font-medium">amyrobson</p>
              <p className="ml-2 opacity-50">1 month ago</p>
            </div>
            <p className="mt-2 leading-5">
              Impressive! Though it seems the drag feature could be improved.
            </p>
          </div>
          <div className="mb-2.5 rounded-xl bg-[#81AFDD] p-2">
            <div className="flex items-center">
              <img
                src="https://img.learntube.ai/public-assets/AI_Syllabus_generator/Oval.png?updatedAt=1689681534956"
                width={32}
                height={32}
                alt=""
              />
              <p className="mx-2 font-medium">amyrobson</p>
              <p className="ml-2 opacity-50">1 month ago</p>
            </div>
            <p className="mt-2 leading-5">
              Impressive! Though it seems the drag feature could be improved.
            </p>
          </div>
          <div className="mb-2.5 rounded-xl bg-[#81AFDD] p-2">
            <div className="flex items-center">
              <img
                src="https://img.learntube.ai/public-assets/AI_Syllabus_generator/Oval.png?updatedAt=1689681534956"
                width={32}
                height={32}
                alt=""
              />
              <p className="mx-2 font-medium">amyrobson</p>
              <p className="ml-2 opacity-50">1 month ago</p>
            </div>
            <p className="mt-2 leading-5">
              Impressive! Though it seems the drag feature could be improved.
            </p>
          </div>
        </div>
        <div className="relative mt-5">
          <input
            type="text"
            placeholder="Write a comment"
            className="answer_text w-full rounded-lg border-none bg-[#17395A] py-3 text-sm placeholder:text-sm placeholder:text-white/50 focus:outline-none"
          />
          <p className="absolute right-4 top-1/2 -translate-y-1/2 transform text-sm text-[#3791EC]">
            Send
          </p>
        </div>
      </div>
    </Dialog>
  );
};

export default CommentModal;
